// Três abas grandes do Férias e Licenças (redesenho 27/10/2026).

import { Box, Button } from '@mui/material';
import { AZUL_ABA } from './visual';

export type Aba = 'por_vir' | 'calendario' | 'passou';

export const CHAVE_ABA = 'tovis-afastamentos-aba';

export function lerAbaSalva(): Aba {
  try {
    const v = window.localStorage.getItem(CHAVE_ABA);
    if (v === 'por_vir' || v === 'calendario' || v === 'passou') return v;
  } catch { /* navegador sem localStorage: abre na primeira aba */ }
  return 'por_vir';
}

export function salvarAba(aba: Aba): void {
  try { window.localStorage.setItem(CHAVE_ABA, aba); } catch { /* sem localStorage: só não lembra */ }
}

interface Props {
  aba: Aba;
  onTrocar: (a: Aba) => void;
  qtdPorVir: number;
  qtdPassou: number;
}

export default function AbasAfastamentos({ aba, onTrocar, qtdPorVir, qtdPassou }: Props) {
  const itens: Array<{ valor: Aba; rotulo: string; selo: string }> = [
    { valor: 'por_vir', rotulo: 'Por vir', selo: String(qtdPorVir) },
    { valor: 'calendario', rotulo: 'Agentes em campo', selo: 'calendário' },
    { valor: 'passou', rotulo: 'Já passou', selo: String(qtdPassou) },
  ];
  return (
    <Box role="tablist" aria-label="Seções do Férias e Licenças" sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 2 }}>
      {itens.map(it => {
        const ativa = it.valor === aba;
        return (
          <Button
            key={it.valor}
            role="tab"
            aria-selected={ativa}
            onClick={() => onTrocar(it.valor)}
            sx={{
              flex: '1 1 200px',
              minHeight: 64,
              borderRadius: 3,
              fontSize: 18,
              fontWeight: 700,
              textTransform: 'none',
              gap: 1.2,
              backgroundColor: ativa ? AZUL_ABA : 'white',
              color: ativa ? 'white' : '#1F2937',
              border: ativa ? `2px solid ${AZUL_ABA}` : '2px solid #D1D5DB',
              '&:hover': { backgroundColor: ativa ? '#1565c0' : '#F3F4F6' },
            }}
          >
            {it.rotulo}
            <Box
              component="span"
              sx={{
                fontSize: 13,
                fontWeight: 700,
                px: 1.2,
                py: 0.3,
                borderRadius: 10,
                backgroundColor: ativa ? 'rgba(255,255,255,0.22)' : '#E5E7EB',
                color: ativa ? 'white' : '#374151',
              }}
            >
              {it.selo}
            </Box>
          </Button>
        );
      })}
    </Box>
  );
}
